export function cx(...args: (string | false | undefined | null)[]) {
  return args.filter(Boolean).join(' ');
}
